





































import { Component, Vue, Prop } from 'vue-property-decorator'
import { required } from 'vuelidate/lib/validators'
import AirlineService from '@/services/AirlineService'
import IAirline from '@/store/interface/IAirline'

@Component({
	name: 'AirlineAutoSuggest',
	validations: {
		modelData: {
			airlineName: {
				required
			}
		}
	}
})
export default class AirlineAutoSuggest extends Vue {
	@Prop()
	private airlineData!: IAirline
	@Prop({ default: false })
	private isDisabled!: boolean
	private modelData: IAirline = { ...this.airlineData }
	private options: IAirline[] = []

	private getAutoSuggestedAirlineList (query: string, update: any): void {
		const locale: string = this.$i18n.locale
		const lang: string = locale && locale.length === 5 ? locale.substring(0, 2) : 'en'

		// API accepts 2 or more characters entered, mock value to show some result on init
		if (query.length < 2) query = 'aa'

		AirlineService.getAirlinesByQuery(query, lang)
			.then((data: any) => {
				const dataIsNotEmpty: boolean = !!data.length
				this.options = dataIsNotEmpty ? data : []

				// update is the callback function of QSelect, that updates the dropdown
				update()
			})
			.catch((e: any) => {
				this.options = []
				update()
			})
	}

	private getOptionLabel (item: IAirline): string {
		return item && item.airlineName ? item.airlineName : ''
	}

	private fieldUpdated (value: IAirline): void {
		this.$emit('field-updated', value)
	}
}
